import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux'
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import TextFieldForm from './parts/TextFieldForm';
import TextAreaFieldForm from './parts/TextAreaFieldForm';
import SelectFieldForm from './parts/SelectFieldForm';
import SaveIcon from '@mui/icons-material/SaveRounded';
import withAlert from '../../hoc/withAlerts'
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { setHeader } from '../../redux/headerSlice'
import Divider from '@mui/material/Divider';
import timezones from 'timezones-list';
import Confirmation from './modals/Confirmation';
import Grow from '@mui/material/Grow';
import UpworkIntegration from './parts/UpworkIntegration';
import Tags from './Tags';
import Prompts from './Prompts';
import Portfolio from './Portfolio';

function Settings(props) {
    const [currentTab, setCurrentTab] = useState(0)
    
    const [testModeFrame, setTestModeFrame] = useState(null);
    const [arhiveDays, setArhiveDays] = useState(null);
    const [purgeDays, setPurgeDays] = useState(null);
    const [suitableThreshold, setSuitableThreshold] = useState(null);
    const [feedContentOwners, setFeedContentOwners] = useState(null);
    const [feedContentProfiles, setFeedContentProfiles] = useState(null);
    const [tagsList, setTagsList] = useState();
    const [timeZoneList, setTimeZoneList] = useState(null)
    const [timeZone, setTimeZone] = useState()
    const [pipedriveUser, setPipedriveUser] = useState(null);
    const [pipedriveUsersList, setPipedriveUsersList] = useState([])
    const [pipedrivePersonLabel, setPipedrivePersonLabel] = useState(null);
    const [pipedrivePersonLabelsList, setPipedrivePersonLabelsList] = useState([])
    const [pipedriveDealFieldList, setPipedriveDealFieldList] = useState([])
    const [pipedriveLeadWebsite, setPipedriveLeadWebsite] = useState(null);
    const [pipedriveLeadContent, setPipedriveLeadContent] = useState(null);
    const [pipedriveLeadGen, setPipedriveLeadGen] = useState(null);
    const [matchExtractPrompt, setMatchExtractPrompt] = useState(null);
    const [matchScorePrompt, setMatchScorePrompt] = useState(null);
    const [matchReasoningEffort, setMatchReasoningEffort] = useState(null);
    const [matchModel, setMatchModel] = useState(null);
    const [matchConcurrency, setMatchConcurrency] = useState(null);

    const token = useSelector((state) => state.auth.token)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setHeader({
            title: 'Settings'
        }))
    }, []);

    useEffect(() => {
        const run = async () => {
            setTestModeFrame(await getSettings('TEST_MODE_SIZE', 25));
            setArhiveDays(await getSettings('ARHIVE_DAYS', 7));
            setPurgeDays(await getSettings('PURGE_DAYS', 30));
            setSuitableThreshold(await getSettings('SUITABLE_THRESHOLD', 50))
            setTimeZone(await getSettings('TIMEZONE', null));
            setFeedContentOwners(await getSettings('FEED_CONTENT_OWNERS', null));
            setFeedContentProfiles(await getSettings('FEED_CONTENT_PROFILES', null));
            setPipedriveUser(await getSettings('PIPEDRIVE_USER', null));
            setPipedrivePersonLabel(await getSettings('PIPEDRIVE_PERSON_LABEL', null));
            
            setTagsList(await getTagsList());
            setTimeZoneList(timezones);            
            
            setPipedriveUsersList(await getPipedriveUsersList());
            setPipedrivePersonLabelsList(await getPipedrivePersonLabelsList());
            
            setPipedriveLeadWebsite(await getSettings('PIPEDRIVE_LEAD_WEBSITE', null));
            setPipedriveLeadContent(await getSettings('PIPEDRIVE_LEAD_CONTENT', null));
            setPipedriveLeadGen(await getSettings('PIPEDRIVE_LEAD_GEN', null));
            
            setPipedriveDealFieldList(await getPipedriveDealFieldList());

            setMatchExtractPrompt(await getSettings('PROFILE_MATCH_EXTRACT_PROMPT', ''));
            setMatchScorePrompt(await getSettings('PROFILE_MATCH_SCORE_PROMPT', ''));
            setMatchReasoningEffort(await getSettings('PROFILE_MATCH_REASONING_EFFORT', 'low'));
            setMatchModel(await getSettings('PROFILE_MATCH_MODEL', 'gpt-5-mini'));
            setMatchConcurrency(await getSettings('PROFILE_MATCH_CONCURRENCY', '4'));
        }
        run()
    }, []);
    
    const getTagsList = async () => {
        let uri = getBackendUrl(endpoints.tags, token)
        try {
            let res = await axios.get(uri)
            return res.data.items
        } catch (e) {
            showAlertError('Unknown Error - get tags list')
        }
        return []
    }
    
    const getPipedriveDealFieldList = async () => {
        let uri = getBackendUrl(endpoints.pipedrive_deals_fields, token)
        try {
            let res = await axios.get(uri)
            return res.data.items
        } catch (e) {
            showAlertError('Unknown Error - get deals fields list')
        }
        return []
    }
    
    const getPipedriveUsersList = async () => {
        let uri = getBackendUrl(endpoints.pipedrive_users, token)
        try {
            let res = await axios.get(uri)
            return res.data.items
        } catch (e) {
            showAlertError('Unknown Error - get users list')
        }
        return []
    }
    
    const getPipedrivePersonLabelsList = async () => {
        let uri = getBackendUrl(endpoints.pipedrive_persons_labels, token)
        try {
            let res = await axios.get(uri)
            return res.data.items
        } catch (e) {
            console.log(e)
            showAlertError('Unknown Error - get person labels list')
        }
        return []
    }
    
    const getSettings = async (name, defaultValue) => {
        let uri = getBackendUrl(endpoints.settings, token).replace('{name}', name)
        try {
            let res = await axios.get(uri);
            return res.data.value ? res.data.value : defaultValue;
        } catch (e) {
            showAlertError('Unknown Error')
        }
        return defaultValue;
    }
    
    const setSettings = async (name, value) => {
        let uri = getBackendUrl(endpoints.settings, token).replace('{name}', name)
        try {
            await axios.put(uri, {
                value: value,
            });
            showAlertSuccess('Data saved successfully');
        } catch (e) {
            showAlertError('Unknown Error')
        }
    }
    
    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={true}>
            <Paper sx={{ maxWidth: 1200, minHeight: '100%', margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={currentTab} onChange={(event, newValue) => {setCurrentTab(newValue)}} aria-label="basic tabs example">
                        <Tab label="General" />
                        <Tab label="Feeds" />
                        <Tab label="PipeDrive" />
                        <Tab label="Integrations" />
                        <Tab label="Tags" />
                        <Tab label="Prompts" />
                        <Tab label="Portfolio" />
                        <Tab label="Match" />
                    </Tabs>
                </Box>
                <div hidden={currentTab !== 0}>
                    <Grid container spacing={2} padding={3}>
                        <Grid item lg={4} md={6} xs={12} sx={{pb:4}}>
                            <Stack spacing={2}>
                                <SelectFieldForm
                                    label="Timezone"
                                    keyField="tzCode"
                                    defaultValue={timeZone}
                                    onSave={(value) => {setSettings('TIMEZONE', value)}}
                                    options={timeZoneList}
                                />

                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <div hidden={currentTab !== 1}>
                    <Grid container spacing={2} padding={3}>
                        <Grid item lg={4} md={6} xs={12} sx={{pb:4}}>
                            <Stack spacing={2}>
                                <TextFieldForm
                                    type="number"
                                    label="Archive records older than Days"
                                    defaultValue={arhiveDays}
                                    onSave={(value) => {setSettings('ARHIVE_DAYS', value)}}
                                />

                                <TextFieldForm
                                    type="number"
                                    label="Permanently delete records older than Days"
                                    defaultValue={purgeDays}
                                    onSave={(value) => {setSettings('PURGE_DAYS', value)}}
                                />

                                <Typography variant="subtitle1" sx={{ pt:4 }}>
                                    Feed Markers
                                </Typography>
                                <TextAreaFieldForm
                                    rows="6"
                                    label="Owners"
                                    defaultValue={feedContentOwners}
                                    onSave={(value) => {setSettings('FEED_CONTENT_OWNERS', value)}}
                                />
                                <TextAreaFieldForm
                                    rows="6"
                                    label="Profiles"
                                    defaultValue={feedContentProfiles}
                                    onSave={(value) => {setSettings('FEED_CONTENT_PROFILES', value)}}
                                />
                                
                                <TextFieldForm
                                    type="number"
                                    label="Conformance assessment threshold for AI mode"
                                    defaultValue={suitableThreshold}
                                    onSave={(value) => {setSettings('SUITABLE_THRESHOLD', value)}}
                                />

                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <div hidden={currentTab !== 2}>
                    <Grid container spacing={2} padding={3}>
                        <Grid item lg={4} md={6} xs={12} sx={{pb:4}}>
                            <Stack spacing={2}>
                                <SelectFieldForm
                                    label="Lead Owner"
                                    defaultValue={pipedriveUser}
                                    onSave={(value) => {setSettings('PIPEDRIVE_USER', value)}}
                                    options={pipedriveUsersList}
                                />
                                <SelectFieldForm
                                    label="Person Labels"
                                    defaultValue={pipedrivePersonLabel}
                                    onSave={(value) => {setSettings('PIPEDRIVE_PERSON_LABEL', value)}}
                                    options={pipedrivePersonLabelsList}
                                />

                                <SelectFieldForm
                                    label="Entry page URL"
                                    defaultValue={pipedriveLeadWebsite}
                                    onSave={(value) => {setSettings('PIPEDRIVE_LEAD_WEBSITE', value)}}
                                    options={pipedriveDealFieldList}
                                />
                                <SelectFieldForm
                                    label="Lead request"
                                    defaultValue={pipedriveLeadContent}
                                    onSave={(value) => {setSettings('PIPEDRIVE_LEAD_CONTENT', value)}}
                                    options={pipedriveDealFieldList}
                                />
                                <SelectFieldForm
                                    label="Leadgen name"
                                    defaultValue={pipedriveLeadGen}
                                    onSave={(value) => {setSettings('PIPEDRIVE_LEAD_GEN', value)}}
                                    options={pipedriveDealFieldList}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <div hidden={currentTab !== 3}>
                    <Grid container spacing={2} padding={3}>
                        <Grid item xs={12} sx={{pb:4}}>
                            {currentTab === 3 ? <UpworkIntegration showAlert={props.showAlert} /> : null}
                        </Grid>
                    </Grid>
                </div>
                <div hidden={currentTab !== 4}>
                    {currentTab === 4 ? <Tags embedded /> : null}
                </div>
                <div hidden={currentTab !== 5}>
                    {currentTab === 5 ? <Prompts embedded /> : null}
                </div>
                <div hidden={currentTab !== 6}>
                    {currentTab === 6 ? <Portfolio embedded /> : null}
                </div>
                <div hidden={currentTab !== 7}>
                    <Grid container spacing={2} padding={3}>
                        <Grid item lg={8} md={10} xs={12} sx={{pb:4}}>
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">
                                    Reasoning effort
                                </Typography>
                                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                    Lower effort scores faster but reasons less carefully. "Low" cut a real match run from ~145s to ~61s with no visible quality loss.
                                </Typography>
                                <SelectFieldForm
                                    label="Reasoning effort"
                                    defaultValue={matchReasoningEffort}
                                    onSave={(value) => {setSettings('PROFILE_MATCH_REASONING_EFFORT', value)}}
                                    options={[
                                        {id: 'minimal', name: 'Minimal (fastest)'},
                                        {id: 'low', name: 'Low (recommended)'},
                                        {id: 'medium', name: 'Medium'},
                                        {id: 'high', name: 'High (most thorough, slowest)'},
                                    ]}
                                />

                                <Typography variant="subtitle1" sx={{ pt: 3 }}>
                                    Model
                                </Typography>
                                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                    OpenAI model used for both the extract and score calls.
                                </Typography>
                                <SelectFieldForm
                                    label="Model"
                                    defaultValue={matchModel}
                                    onSave={(value) => {setSettings('PROFILE_MATCH_MODEL', value)}}
                                    options={[
                                        {id: 'gpt-5-mini', name: 'gpt-5-mini (recommended)'},
                                        {id: 'gpt-5', name: 'gpt-5'},
                                        {id: 'gpt-5-nano', name: 'gpt-5-nano'},
                                        {id: 'o4-mini-2025-04-16', name: 'o4-mini-2025-04-16'},
                                    ]}
                                />

                                <Typography variant="subtitle1" sx={{ pt: 3 }}>
                                    Profiles processed at once
                                </Typography>
                                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                    How many roster profiles are scored in parallel per match run (1-20). Higher is faster but more likely to hit an OpenAI rate limit under load.
                                </Typography>
                                <TextFieldForm
                                    type="number"
                                    label="Concurrency"
                                    defaultValue={matchConcurrency}
                                    onSave={(value) => {setSettings('PROFILE_MATCH_CONCURRENCY', value)}}
                                />

                                <Typography variant="subtitle1" sx={{ pt: 3 }}>
                                    Extract prompt
                                </Typography>
                                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                    System prompt used to pull mandatory skills and key concepts out of a job description, once per match run.
                                </Typography>
                                <TextAreaFieldForm
                                    rows="10"
                                    label="Extract prompt"
                                    defaultValue={matchExtractPrompt}
                                    onSave={(value) => {setSettings('PROFILE_MATCH_EXTRACT_PROMPT', value)}}
                                />

                                <Typography variant="subtitle1" sx={{ pt: 3 }}>
                                    Score prompt
                                </Typography>
                                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                    System prompt used to score each freelancer profile against the extracted skills and concepts — runs once per visible profile.
                                </Typography>
                                <TextAreaFieldForm
                                    rows="18"
                                    label="Score prompt"
                                    defaultValue={matchScorePrompt}
                                    onSave={(value) => {setSettings('PROFILE_MATCH_SCORE_PROMPT', value)}}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        </Grow>
    );
}

export default withAlert(Settings)